// German UI texts, used with translate.js (see client/i18n.js)
export default {
  // header
  'app.signIn': 'Mit GitHub anmelden',
  'app.tagline':
    'Issues, Pull Requests und Berechtigungen kommen direkt von GitHub.',
  'app.signOut': 'Abmelden',
  'app.home': 'Alle Repositories',
  'app.language': 'Sprache',
  'repo.switch': 'Repository wechseln',
  'repo.select': 'Repository auswählen',
  'repo.openOnGithub': '{repo} auf GitHub öffnen',
  'repo.loading': 'Repositories werden geladen…',
  'repo.none': 'Keine Repositories',
  'repo.noneHint':
    'Installiere die GitHub App in einem Repository, auf das du Zugriff hast, und lade dann neu.',
  'repo.list': 'Repositories',
  'repo.private': 'privat',

  'task.createIssue': 'Issue aus dieser Aufgabe erstellen',
  'task.issueBody': 'Aus #{number}',
  'button.busy': 'Läuft…',

  // toolbar
  'filter.search': 'Nach Titel oder #Nummer filtern',
  'filter.searchHint':
    'Nach Titel filtern, oder #Nummer für ein einzelnes Issue',
  'filter.by': 'Nach {name} filtern',
  'filter.type': 'Typ',
  'filter.assignee': 'Zuständig',
  'filter.label': 'Label',
  'filter.milestone': 'Meilenstein',
  'filter.issues': 'Issues',
  'filter.pulls': 'Pull Requests',
  'filter.unassigned': 'Niemand zuständig',
  'filter.clear': 'Zurücksetzen',
  'filter.clearHint': 'Alle Filter entfernen',
  'live.on': 'Live',
  'live.off': 'Offline',
  'live.onHint': 'Live-Aktualisierung verbunden',
  'live.offHint':
    'Live-Aktualisierung nicht verbunden, Änderungen anderer erscheinen nach dem Neuladen',
  'board.updating': 'Wird aktualisiert…',
  'board.loading': 'Board wird geladen…',
  'board.configError': '{error}: Standard-Spalten werden verwendet',
  'board.refreshFailed': 'Aktualisieren fehlgeschlagen: {error}',

  // lanes
  'lane.cards': { 1: '{n} Karte', n: '{n} Karten' },
  'lane.wip': 'WIP-Limit {wip}',
  'lane.newIssue': 'Neues Issue in {lane}',
  'lane.newIssuePlaceholder': 'Titel, Enter zum Anlegen, Esc zum Schließen',
  'lane.done': '{name} · {days} T.',
  'lane.doneHint': 'In den letzten {days} Tagen geschlossen',

  // cards
  'card.creating': 'wird angelegt…',
  'card.openOnGithub': 'Auf GitHub öffnen',
  'card.open': '#{number} öffnen',
  'card.comments': { 1: '{n} Kommentar', n: '{n} Kommentare' },
  'card.closes': 'Schließt',
  'card.linkedPulls': 'Verknüpfte Pull Requests',
  'card.setMilestone': 'Meilenstein setzen',
  'card.applyLabels': 'Labels vergeben',
  'card.assign': 'Personen zuweisen',
  'card.assignHeading': 'Bis zu 10 Personen zuweisen',
  'card.issue': 'Issue',
  'card.pull': 'Pull Request',
  'state.open': 'Offen',
  'state.closed': 'Geschlossen',
  'state.merged': 'Gemergt',
  'state.draft': 'Entwurf',

  // pull requests
  'checks.SUCCESS': 'Checks erfolgreich',
  'checks.PENDING': 'Checks laufen',
  'checks.EXPECTED': 'Checks erwartet',
  'checks.FAILURE': 'Checks fehlgeschlagen',
  'checks.ERROR': 'Checks mit Fehler',
  'review.APPROVED': 'Freigegeben',
  'review.CHANGES_REQUESTED': 'Änderungen angefordert',
  'review.REVIEW_REQUIRED': 'Review erforderlich',
  'merge.method.merge': 'Merge-Commit erstellen',
  'merge.method.squash': 'Squash and merge',
  'merge.method.rebase': 'Rebase and merge',
  'merge.methodHint.merge':
    'Alle Commits kommen über einen Merge-Commit in den Ziel-Branch',
  'merge.methodHint.squash':
    'Die Commits werden zu einem Commit im Ziel-Branch zusammengefasst',
  'merge.methodHint.rebase': 'Die Commits werden auf den Ziel-Branch rebased',
  'merge.commits': {
    1: '{n} Commit von {branch} in {base}',
    n: '{n} Commits von {branch} in {base}',
  },
  'merge.deleteBranch': 'Branch {branch} löschen',
  'merge.doneDeleted': '#{number} gemergt und Branch {branch} gelöscht',
  'merge.waitForChecks': 'Auf grüne Checks warten',
  'merge.button': 'Mergen',
  'merge.choose': 'Mergen: Methode wählen',
  'merge.busy': 'Wird gemergt…',
  'merge.done': '#{number} gemergt',
  'merge.headMoved':
    'Der Pull Request hat sich geändert, prüfe ihn noch einmal',
  'merge.blocked.noWrite': 'Keine Schreibrechte',
  'merge.blocked.disabled': 'Mergen ist für das Repo deaktiviert',
  'merge.blocked.draft': 'Entwurf',
  'merge.blocked.loading': 'Status wird geladen…',
  'merge.blocked.checks': 'Checks nicht grün',
  'merge.blocked.BEHIND': 'Branch ist hinter dem Ziel-Branch',
  'merge.blocked.BLOCKED': 'Durch Branch-Schutz blockiert',
  'merge.blocked.DIRTY': 'Merge-Konflikte',
  'merge.blocked.UNKNOWN': 'Merge-Fähigkeit wird geprüft…',
  'merge.blocked.UNSTABLE': 'Checks nicht grün',
  'rebase.button': 'Branch rebasen',
  'rebase.hint': '{branch} auf {base} rebasen: GitHub kann das ohne Konflikte',
  'rebase.busy': 'Wird rebased…',
  'rebase.done': '{branch} auf {base} rebased',
  'branch.delete': 'Branch löschen',
  'branch.deleteHint': 'Branch {branch} löschen',
  'branch.deleting': 'Wird gelöscht…',
  'branch.deleted': 'Branch {branch} gelöscht',
  'branch.deleteFailed':
    'Branch {branch} konnte nicht gelöscht werden: {error}',
  'claude.title': 'Claude Code',
  'claude.cli': 'Claude im Terminal',
  'claude.cliHint': {
    issue: 'Mit Claude Code in einem Terminal an #{number} arbeiten',
    pr: '#{number} mit Claude Code in einem Terminal reviewen',
    conflicts:
      'Merge-Konflikte von #{number} mit Claude Code in einem Terminal lösen',
  },
  'claude.vscode': 'Claude in VS Code',
  'claude.vscodeHint': {
    issue: 'Mit Claude Code in VS Code an #{number} arbeiten',
    pr: '#{number} mit Claude Code in VS Code reviewen',
    conflicts: 'Merge-Konflikte von #{number} mit Claude Code in VS Code lösen',
  },
  'pr.vscode': 'In VS Code auschecken',
  'pr.vscodeHint': 'In VS Code auschecken (Erweiterung GitHub Pull Requests)',
  'pr.copyBranch': 'Branch kopieren',
  'pr.copyBranchHint': 'Branch-Namen kopieren: {branch}',
  'pr.copied': 'Kopiert',
  'pr.copyFailed': 'Kopieren fehlgeschlagen: {error}',
  'pr.statusFailed': 'Pull-Request-Status konnte nicht geladen werden: {error}',

  // detail
  'detail.close': 'Schließen (Esc)',
  'detail.conversation': 'Unterhaltung',
  'detail.filesChanged': 'Geänderte Dateien',
  'diff.loading': 'Änderungen werden geladen…',
  'diff.files': { 1: '{n} Datei geändert', n: '{n} Dateien geändert' },
  'diff.commits': { 1: '{n} Commit', n: '{n} Commits' },
  'diff.pickCommit': 'Änderungen zeigen von',
  'diff.allCommits': 'Alle Commits',
  'diff.viewed': 'Angesehen',
  'diff.viewedCount': '{viewed} / {total} angesehen',
  'diff.changedSinceViewed': 'Seit dem Ansehen geändert',
  'diff.viewedFailed': 'Angesehen konnte nicht gespeichert werden: {error}',
  'diff.none': 'Keine Änderungen',
  'diff.comments': { 1: '{n} Kommentar', n: '{n} Kommentare' },
  'diff.resolved': 'Gelöst',
  'diff.notShown':
    'Kein Diff: Binärdatei, oder zu groß, als dass GitHub ihn mitschickt',
  'diff.viewOnGithub': 'Auf GitHub ansehen',
  'diff.status.added': 'neu',
  'diff.status.removed': 'gelöscht',
  'diff.status.renamed': 'umbenannt',
  'diff.status.copied': 'kopiert',
  'diff.status.changed': 'geändert',
  'detail.loading': 'Wird geladen…',
  'detail.titleHint': 'Klicken, um den Titel zu bearbeiten',
  'detail.opened': 'hat {time} eröffnet',
  'detail.commented': 'hat {time} kommentiert',
  'detail.edit': 'Bearbeiten',
  'detail.delete': 'Kommentar löschen',
  'detail.deleteConfirm': 'Zum Löschen erneut klicken',
  'detail.deleteShort': 'Löschen?',
  'detail.emptyComment': 'Der Kommentar ist leer. Löschen?',
  'detail.keepEditing': 'Weiter bearbeiten',
  'detail.saving': 'wird gespeichert…',
  'detail.notSaved': 'nicht gespeichert, zum Wiederholen bearbeiten',
  'detail.lane': 'Spalte',
  'detail.moveToLane': 'In Spalte verschieben',
  'detail.assignees': 'Zuständig',
  'detail.noOne': 'Niemand',
  'detail.assignYourself': 'selbst übernehmen',
  'detail.labels': 'Labels',
  'detail.noLabels': 'Noch keine',
  'detail.milestone': 'Meilenstein',
  'detail.noMilestone': 'Kein Meilenstein',
  'detail.noMilestones': 'Noch keine Meilensteine — ',
  'detail.createMilestone': 'einen anlegen',
  'detail.pullRequest': 'Pull Request',
  'detail.development': 'Entwicklung',
  'detail.addComment': 'Kommentar hinzufügen',
  'detail.commentPlaceholder':
    'Kommentar schreiben… Bilder einfügen oder hineinziehen',
  'detail.comment': 'Kommentieren',
  'detail.update': 'Aktualisieren',
  'detail.closeIssue': 'Issue schließen',
  'detail.closeIssueHint': 'Issue als erledigt schließen',
  'detail.reopenIssue': 'Issue wieder öffnen',
  'detail.closePr': 'Pull Request schließen',
  'detail.closePrHint': 'Diesen Pull Request schließen, ohne zu mergen',
  'detail.reopenPr': 'Pull Request wieder öffnen',
  'detail.noDescription': 'Keine Beschreibung',
  'detail.createFailed': '„{title}“ konnte nicht angelegt werden: {error}',

  // editor
  'editor.write': 'Schreiben',
  'editor.writeHint': 'Markdown bearbeiten',
  'editor.preview': 'Vorschau',
  'editor.previewHint': 'Zeigen, wie der Text aussehen wird',
  'editor.heading': 'Überschrift einfügen',
  'editor.bold': 'Fetten Text einfügen',
  'editor.italic': 'Kursiven Text einfügen',
  'editor.quote': 'Zitat einfügen',
  'editor.code': 'Code einfügen',
  'editor.link': 'Link einfügen',
  'editor.bullets': 'Aufzählung einfügen',
  'editor.numbers': 'Nummerierte Liste einfügen',
  'editor.tasks': 'Aufgabenliste einfügen',
  'editor.placeholder': 'Markdown schreiben… Bilder einfügen oder hineinziehen',
  'editor.nothing': 'Nichts für die Vorschau',
  'editor.attach': 'Bilder einfügen, hineinziehen oder auswählen',
  'editor.attachHint': 'Bilder anhängen',
  'editor.uploading': '{n} wird hochgeladen…',
  'editor.notImage': '{name} ist kein Bild',
  'editor.cancel': 'Abbrechen',
  'editor.cancelHint': 'Änderungen verwerfen (Esc)',
  'editor.save': 'Speichern',
  'editor.saveHint': 'Speichern (Cmd/Strg+Enter)',
  'editor.saving': 'Wird gespeichert…',

  // settings
  'settings.title': 'Einstellungen',
  'settings.open': 'Einstellungen: Sprache, was Karten zeigen',
  'settings.laneWidth': 'Spaltenbreite',
  'settings.laneWidth.narrow': 'Schmal',
  'settings.laneWidth.normal': 'Normal',
  'settings.laneWidth.wide': 'Breit',
  'settings.claudeCliHint':
    'Button auf offenen Issues und Pull Requests, der Claude Code in einem Terminal startet, in deinem Klon des Repos. Funktioniert, sobald du auf diesem Rechner eine Nachricht in Claude Code geschickt hast.',
  'settings.claudeVscodeHint':
    'Button auf offenen Issues und Pull Requests, der einen Claude-Code-Tab im aktiven VS-Code-Fenster öffnet (Erweiterung Claude Code)',
  'settings.board': 'Board',
  'settings.hideIssuesWithPr': 'Issues mit offenem Pull Request ausblenden',
  'settings.hideIssuesWithPrHint':
    'Solange der Pull Request offen ist, steht seine Karte für das Issue',
  'settings.cards': 'Karten zeigen',
  'settings.cardLabels': 'Labels',
  'settings.cardLabelsHint':
    'Label auf den Karten (im Issue bleiben sie bearbeitbar)',
  'settings.cardLinks': 'Verknüpfte Issues und Pull Requests',
  'settings.cardLinksHint':
    'Mit einem Issue verknüpfte Pull Requests, von einem Pull Request geschlossene Issues',
  'settings.cardVscodeHint':
    'Button auf Pull-Request-Karten, um den Branch in VS Code auszuchecken',
  'settings.cardCopyBranchHint':
    'Button auf Pull-Request-Karten, um den Branch-Namen zu kopieren',
  'settings.local': 'Wird in diesem Browser gespeichert.',

  // timeline
  'event.assigned': '{actor} hat {user} zugewiesen',
  'event.assignedSelf': '{actor} hat sich das zugewiesen',
  'event.unassigned': '{actor} hat {user} entfernt',
  'event.unassignedSelf': '{actor} hat sich als zuständig entfernt',
  'event.labelsAdded': '{actor} hat {added} hinzugefügt',
  'event.labelsRemoved': '{actor} hat {removed} entfernt',
  'event.labelsChanged':
    '{actor} hat {added} hinzugefügt und {removed} entfernt',
  'event.moved': '{actor} hat das von {from} nach {to} verschoben',
  'event.movedTo': '{actor} hat das nach {to} verschoben',
  'event.movedOut': '{actor} hat das aus {from} genommen',
  'event.milestoned': '{actor} hat das dem Meilenstein {milestone} zugeordnet',
  'event.demilestoned':
    '{actor} hat das aus dem Meilenstein {milestone} entfernt',
  'event.closed': '{actor} hat das geschlossen',
  'event.closedCompleted': '{actor} hat das als erledigt geschlossen',
  'event.closedNotPlanned': '{actor} hat das als nicht geplant geschlossen',
  'event.reopened': '{actor} hat das wieder geöffnet',
  'event.merged': '{actor} hat das gemergt',
  'event.renamed': '{actor} hat den Titel {from} in {to} geändert',
  'event.referenced': '{actor} hat das in {source} erwähnt',
  'event.approved': '{actor} hat die Änderungen freigegeben',
  'event.changesRequested': '{actor} hat Änderungen angefordert',
  'event.reviewDismissed': '{actor}s Review wurde verworfen',

  // menus
  'menu.filter': 'Filtern',
  'menu.shiftHint': 'Mit ⇧-Klick mehrere wählen',
  'menu.apply': 'Übernehmen',
  'menu.applyHint': 'Auswahl übernehmen (Enter)',
  'menu.empty': 'Nichts gefunden',

  // time
  'time.justNow': 'gerade eben',
}
